<div class="m-form-field">
  <div class="a-search-input" [class.--close-visible]="value$ | async">
    <label *ngIf="label" [for]="id"> {{ label }} <ng-container *ngIf="isRequired$ | async">*</ng-container> </label>

    <input
      [id]="id"
      [formControl]="control"
      [placeholder]="placeholder"
      [readonly]="readonly"
      [disabled]="isDisabled$ | async"
      [boschUiInputAutofocus]="autofocus"
      type="search"
    />

    <button
      type="button"
      class="a-search-input__icon-close tw-bg-bosch-gray-85 hover:tw-bg-bosch-gray-75"
      (click)="onClear()"
    >
      <bosch-ui-icon [name]="iconNames.CloseSmall"></bosch-ui-icon>
    </button>
    <button type="submit" class="a-search-input__icon-search" aria-label="Search" (click)="onSearch()">
      <bosch-ui-icon [name]="iconNames.Search"></bosch-ui-icon>
    </button>
  </div>
  <bosch-ui-validation-error
    *ngIf="!errorRef && (error$ | async) as error"
    [error]="'common.validation.error.' + error | translate"
  ></bosch-ui-validation-error>
  <ng-container *ngIf="errorRef">
    <ng-content></ng-content>
  </ng-container>
</div>
